<qvs-status-screen
  class="qvs-validate-payment-order-request-uploading"
  *ngIf="ordersPaymentRequest as request"
  [title]="'shared.status-screen.PROCESSING' | translate"
  [type]="request.waitingForAccessAppConfirmation ? statusScreenType.APP_SWITCH : statusScreenType.PENDING"
  [showCloseButton]="request.status === status.userSubmitFailure"
  [closeButtonText]="'payments.CANCEL' | translate"
  (closed)="close()"
>
  <ng-container *ngIf="request.payment as payment">
    <h2 class="qvs-validate-payment-order-request-uploading__title">
      <span *ngIf="!request.waitingForAccessAppConfirmation">{{ 'payments.PAYMENT_TRANSMITTING' | translate }}</span>
      <span *ngIf="request.waitingForAccessAppConfirmation">
        {{ 'payments.AUTHENTICATING_INSTRUCTION_TITLE' | translate }}
      </span>
      <ion-spinner name="dots" color="primary" duration="2000"></ion-spinner>
    </h2>
    <div class="qvs-validate-payment-order-request-uploading__description">
      <p
        *ngIf="request.waitingForAccessAppConfirmation"
        class="qvs-validate-payment-order-request-uploading__description__authentication"
        [innerHTML]="'payments.AUTHENTICATING_INSTRUCTION_TEXT' | translate"
      ></p>
      <ng-container *ngIf="!request.waitingForAccessAppConfirmation">
        <p class="qvs-validate-payment-order-request-uploading__description__beneficiary">
          {{ payment.beneficiaryName }}
        </p>
        <p
          class="qvs-validate-payment-order-request-uploading__description__amount"
          [innerHTML]="
            { value: payment.amount, currency: payment.currency?.currency }
              | amount: true : undefined : undefined : undefined : payment.account?.currencyId
          "
        ></p>
        <p *ngIf="payment.executionDate" class="qvs-validate-payment-order-request-uploading__description__date">
          {{ payment.executionDate | localDate }}
        </p>
      </ng-container>
    </div>
  </ng-container>
  <ng-container *ngIf="request.transfer as transfer">
    <h2 class="qvs-validate-payment-order-request-uploading__title">
      <span *ngIf="!request.waitingForAccessAppConfirmation">{{ 'payments.TRANSFER_TRANSMITTING' | translate }}</span>
      <span *ngIf="request.waitingForAccessAppConfirmation">
        {{ 'payments.AUTHENTICATING_INSTRUCTION_TITLE' | translate }}
      </span>
      <ion-spinner name="dots" color="primary" duration="2000"></ion-spinner>
    </h2>
    <div class="qvs-validate-payment-order-request-uploading__description">
      <p
        *ngIf="request.waitingForAccessAppConfirmation"
        class="qvs-validate-payment-order-request-uploading__description__authentication"
        [innerHTML]="'payments.AUTHENTICATING_INSTRUCTION_TEXT' | translate"
      ></p>
      <ng-container *ngIf="!request.waitingForAccessAppConfirmation">
        <p
          class="qvs-validate-payment-order-request-uploading__description__amount"
          [innerHTML]="
            { value: transfer.amount, currency: transfer.debitAccount.currencyId }
              | amount: true : undefined : undefined : undefined : transfer.creditAccount.currencyId
          "
        ></p>
        <p class="qvs-validate-payment-order-request-uploading__description__portfolio">
          <span>{{ transfer.debitAccount.portfolio.name }}</span>
          <span>
            {{ transfer.debitAccount.currencyId }} {{ transfer.debitAccount.portfolio.portfolioNumber | accountIdShorten }}
          </span>
        </p>
        <p *ngIf="transfer.executionDate" class="qvs-validate-payment-order-request-uploading__description__date">
          {{ transfer.executionDate | localDate }}
        </p>
      </ng-container>
    </div>
  </ng-container>
</qvs-status-screen>
